import { Component, OnInit, ViewChild } from '@angular/core';
import { InputComponent, MakeProvider } from '../input-component';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
  providers: [MakeProvider(PhoneInputComponent)]
})
export class PhoneInputComponent extends InputComponent implements OnInit {

  @ViewChild('phoneInput', { static: false }) phoneInput: IonInput;

  key: string = null;
  override maxLength = 15;
  private currNumValue = '';
  private isMasking = false;

  constructor() { super(); }

  ngOnInit() {
    setTimeout(() => {
      this.phoneInput.value = this.value;
      this.phoneInput.value = this.doMaskInput(<string>this.phoneInput.value);
      document.getElementById(this.id)?.addEventListener('keydown', (event) => {
        this.key = event.key;
      });
    }, 1);
  }

  maskInput(event) {
    event.target.value = this.doMaskInput(event.target.value);
  }

  doMaskInput(value: string) {
    const arr: string[] = this.getNumbers(value);
    // checks if delete or backspace key was hit
    // if it was hit we shorten the length of the number by 1
    if (this.key === 'Backspace' || this.key === 'Delete') {
      this.key = null;
      if (arr.length > 0 && arr.length <= 6 && !value.endsWith('-')) {
        arr.length = arr.length - 1;
      }
    }
    const numbers = arr.join('');
    this.currNumValue = numbers; // store the current number value this way if the value changes we can ensure this is the value we expect
    this.value = numbers;
    return this.getDisplayStringForCurrentValue();
  }

  override checkValidity() {
    const numbers = this.getNumbers(this.value);
    if (numbers.length < 10) {
      this.focusInvalidElement('Enter a valid phone number.');
    } else {
      this.isValid = true;
      this.checkingValidity.emit(this);
    }
  }

  protected getNumbers(value: string) {
    if (value) {
        const val = value.toString();
        const arr: string[] = [];
        for (let i = 0; i < val.toString().length; i++) {
            //checks if input is a digit
            if (val[i]?.match('\\d')) {
            arr.push(val[i]!);
            }
        }
        return arr;
    }
    return [];
  }

  protected override updateValue(): void {
    if (this.phoneInput && this.value == null) {
      // the value was nulled out (can happen if we re-bind to a new value) so we need to clear the input
      this.phoneInput.value = '';
    } else if (this.phoneInput && this.value !== this.currNumValue) {
      // the value has changed so we need to update the input (can happen if we re-bind to a new value)
      this.phoneInput.value = this.getDisplayStringForCurrentValue();
    }
  }

  private getDisplayStringForCurrentValue() {
    return this.value.length > 0 ? `(${this.value.slice(0, 3)}) ${this.value.slice(3, 6)}-${this.value.slice(6, 10)}` : '';
  }
}
